import React from "react"
import DropArea from "./DropArea"
import DndItem from "./DndItem"
import {Stack} from "@mui/material"
import Typography from "@mui/material/Typography"

const DropAreaWithItems = ({ id, title, items, savePointer, onRemove }) => (
    <Stack spacing={2}>
        <Typography fontWeight={500} fontSize="20px" lineHeight="24px">{title}</Typography>
        <DropArea id={id} title={title}>
            {items.map((item) => (
                <DndItem
                    savePointer={savePointer}
                    key={item.id}
                    containerId={id}
                    item={item}
                    id={item.id}
                    isInDropArea
                    position={{ x: item.x, y: item.y }}
                    onRemove={(itemId) => onRemove(id, itemId)}
                />
            ))}
        </DropArea>
    </Stack>
)

export default DropAreaWithItems